/* LSL · Simulateur (accueil et fiches) : un son différent pour Blaster, Lock-up, Estoc et Melt.
   Vrais sons : ceux de la carte NeoPixel (SNV4 Pro, envoyés par le fournisseur le 02/11), un fichier par profil et par effet
   dans Contenu > Fichiers (lsl-snv4-<n>-blaster.mp3, -lockup, -stab, -melt ; liens data-blaster… posés par snippets/lsl-cb-sim.liquid).
   Si un fichier manque, l'effet est recréé dans le navigateur à partir des sons du profil choisi :
   - Blaster : le choc plus aigu et sec, avec un tir qui descend ;
   - Lock-up : le choc découpé en grésillement continu ;
   - Estoc : un coup court et appuyé ;
   - Melt : le swing ralenti avec un souffle brûlant.
   Clash et Smooth Swing gardent leurs vrais sons.
   Principe : lsl-cb2.js (fiches) et lsl-sim.js (accueil) lisent data-impact / data-swing du profil choisi au moment de jouer.
   Juste avant (écoute en phase de capture), on y met la variante de l'effet touché, puis on remet l'original.
   Chargé par snippets/lsl-cb-sim.liquid. */
(() => {
  'use strict';
  const OAC = window.OfflineAudioContext || window.webkitOfflineAudioContext;
  if (!OAC || !window.Blob || !window.URL) return;
  const VAR = { blaster: 'impact', lockup: 'impact', stab: 'impact', melt: 'swing' };
  const decoded = new Map(), made = new Map(), ready = new Map(), real = new Map(), realOk = new Set();
  /* vrai fichier présent ? (un octet suffit) */
  const checkReal = url => {
    if (!real.has(url)) real.set(url, fetch(url, { headers: { Range: 'bytes=0-1' } }).then(r => { if (r.ok) realOk.add(url); return r.ok; }).catch(() => false));
    return real.get(url);
  };

  const decode = url => {
    if (!decoded.has(url)) decoded.set(url, fetch(url).then(r => r.arrayBuffer()).then(a => new Promise((res, rej) => new OAC(1, 1, 44100).decodeAudioData(a, res, rej))));
    return decoded.get(url);
  };
  const noise = (c, dur) => {
    const b = c.createBuffer(1, Math.ceil(dur * c.sampleRate), c.sampleRate), d = b.getChannelData(0);
    for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
    const n = c.createBufferSource(); n.buffer = b; return n;
  };
  const filt = (c, type, f, q) => { const x = c.createBiquadFilter(); x.type = type; x.frequency.value = f; if (q) x.Q.value = q; return x; };
  const gain = (c, v) => { const g = c.createGain(); g.gain.value = v; return g; };

  const R = {
    blaster: { dur: 0.7, build(c, b) {
      const s = c.createBufferSource(); s.buffer = b; s.playbackRate.value = 1.5;
      const g = gain(c, 1); g.gain.setValueAtTime(1, 0); g.gain.exponentialRampToValueAtTime(0.001, 0.6);
      s.connect(filt(c, 'highpass', 650)).connect(g).connect(c.destination); s.start(0);
      const o = c.createOscillator(); o.type = 'sawtooth';
      o.frequency.setValueAtTime(2600, 0); o.frequency.exponentialRampToValueAtTime(300, 0.17);
      const og = gain(c, 0.0001); og.gain.exponentialRampToValueAtTime(0.22, 0.01); og.gain.exponentialRampToValueAtTime(0.0001, 0.19);
      o.connect(filt(c, 'lowpass', 3200)).connect(og).connect(c.destination); o.start(0); o.stop(0.2);
    } },
    lockup: { dur: 1.75, build(c, b) {
      const out = gain(c, 1); out.gain.setValueAtTime(1, 1.45); out.gain.linearRampToValueAtTime(0, 1.75); out.connect(c.destination);
      const span = Math.max(0.05, Math.min(0.25, b.duration - 0.1));
      for (let t = 0; t < 1.6; t += 0.055) {
        const s = c.createBufferSource(); s.buffer = b; s.playbackRate.value = 0.85 + Math.random() * 0.4;
        const g = gain(c, 0); const a = 0.45 + Math.random() * 0.45;
        g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(a, t + 0.006); g.gain.exponentialRampToValueAtTime(0.001, t + 0.09);
        s.connect(g).connect(out); s.start(t, Math.random() * span, 0.1);
      }
      const n = noise(c, 1.75), ng = gain(c, 0.12);
      for (let t = 0; t < 1.7; t += 0.04) ng.gain.setValueAtTime(0.06 + Math.random() * 0.14, t);
      n.connect(filt(c, 'bandpass', 2400, 1.1)).connect(ng).connect(out); n.start(0);
    } },
    stab: { dur: 0.55, build(c, b) {
      const s = c.createBufferSource(); s.buffer = b; s.playbackRate.value = 1.22;
      const g = gain(c, 1.1); g.gain.setValueAtTime(1.1, 0); g.gain.exponentialRampToValueAtTime(0.001, 0.5);
      s.connect(filt(c, 'lowpass', 5200)).connect(g).connect(c.destination); s.start(0);
      const o = c.createOscillator(); o.type = 'sine';
      o.frequency.setValueAtTime(110, 0); o.frequency.exponentialRampToValueAtTime(48, 0.14);
      const og = gain(c, 0.0001); og.gain.exponentialRampToValueAtTime(0.7, 0.008); og.gain.exponentialRampToValueAtTime(0.0001, 0.16);
      o.connect(og).connect(c.destination); o.start(0); o.stop(0.18);
    } },
    melt: { dur: 2.05, build(c, b) {
      const out = gain(c, 1); out.gain.setValueAtTime(0, 0); out.gain.linearRampToValueAtTime(1, 0.15); out.gain.setValueAtTime(1, 1.7); out.gain.linearRampToValueAtTime(0, 2.05); out.connect(c.destination);
      const s = c.createBufferSource(); s.buffer = b; s.loop = true; s.playbackRate.value = 0.72;
      s.connect(filt(c, 'lowpass', 1300)).connect(gain(c, 0.75)).connect(out); s.start(0);
      const n = noise(c, 2.05), ng = gain(c, 0.04);
      for (let t = 0.2; t < 1.9; t += 0.05) ng.gain.setValueAtTime(0.1 + Math.random() * 0.2 * (t / 1.9), t);
      n.connect(filt(c, 'bandpass', 3400, 0.8)).connect(ng).connect(out); n.start(0);
    } }
  };

  const wav = buf => {
    const ch = buf.numberOfChannels, len = buf.length, sr = buf.sampleRate, size = 44 + len * ch * 2;
    const v = new DataView(new ArrayBuffer(size)); let p = 0;
    const w = s => { for (let i = 0; i < s.length; i++) v.setUint8(p++, s.charCodeAt(i)); };
    const u32 = x => { v.setUint32(p, x, true); p += 4; }, u16 = x => { v.setUint16(p, x, true); p += 2; };
    w('RIFF'); u32(size - 8); w('WAVE'); w('fmt '); u32(16); u16(1); u16(ch); u32(sr); u32(sr * ch * 2); u16(ch * 2); u16(16); w('data'); u32(len * ch * 2);
    const data = []; for (let k = 0; k < ch; k++) data.push(buf.getChannelData(k));
    for (let i = 0; i < len; i++) for (let k = 0; k < ch; k++) { const x = Math.max(-1, Math.min(1, data[k][i])); v.setInt16(p, x < 0 ? x * 0x8000 : x * 0x7FFF, true); p += 2; }
    return URL.createObjectURL(new Blob([v], { type: 'audio/wav' }));
  };
  const make = (fx, url) => {
    const key = fx + '|' + url;
    if (!made.has(key)) {
      made.set(key, decode(url).then(b => {
        const V = R[fx], c = new OAC(1, Math.ceil(V.dur * b.sampleRate), b.sampleRate);
        V.build(c, b);
        return new Promise((res, rej) => { c.oncomplete = e => res(e.renderedBuffer); const r = c.startRendering(); if (r && r.then) r.then(res, rej); });
      }).then(buf => { const u = wav(buf); ready.set(key, u); return u; }).catch(() => { made.delete(key); }));
    }
    return made.get(key);
  };

  const orig = (li, kind) => li.dataset[kind === 'impact' ? 'lslOImpact' : 'lslOSwing'];
  const restore = li => {
    if (li.dataset.lslOImpact) li.dataset.impact = li.dataset.lslOImpact;
    if (li.dataset.lslOSwing) li.dataset.swing = li.dataset.lslOSwing;
  };
  function bind(s) {
    if (s.dataset.lslSfx) return;
    s.dataset.lslSfx = '1';
    const srcs = Array.from(s.querySelectorAll('[data-sim-src]')), sel = s.querySelector('[data-sim-profile]');
    srcs.forEach(li => { li.dataset.lslOImpact = li.dataset.impact || ''; li.dataset.lslOSwing = li.dataset.swing || ''; });
    const cur = () => srcs[+(sel && sel.value) || 0] || srcs[0];
    const prep = () => {
      const li = cur(); if (!li) return;
      Object.keys(VAR).forEach(fx => {
        const u = orig(li, VAR[fx]), ru = li.dataset[fx];
        if (ru) checkReal(ru).then(ok => { if (!ok && u) make(fx, u); });
        else if (u) make(fx, u);
      });
    };
    s.addEventListener('click', e => {
      const b = e.target.closest('[data-lsl-fx]'); const li = cur(); if (!b || !li) return;
      restore(li);
      const fx = b.dataset.lslFx, kind = VAR[fx]; if (!kind) return;
      const ru = li.dataset[fx];
      const u = ru && realOk.has(ru) ? ru : ready.get(fx + '|' + orig(li, kind));
      if (!u) { prep(); return; }
      li.dataset[kind] = u;
      clearTimeout(li._lslSfx); li._lslSfx = setTimeout(() => restore(li), 1500);
    }, true);
    ['pointerenter', 'pointerdown', 'focusin'].forEach(ev => s.addEventListener(ev, prep, { passive: true }));
    if (sel) sel.addEventListener('change', prep);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => { if (es.some(x => x.isIntersecting)) { io.disconnect(); prep(); } }, { rootMargin: '200px' });
      io.observe(s);
    }
  }
  const run = () => document.querySelectorAll('.lsl-sim[data-mq-sim]').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
